<template>
  <label class="py-1 block">
    <span class="flex justify-between items-center">
      <span class="text-sm" v-text="label" />
      <span v-if="error" class="pl-2 pr-1 text-gray-500 text-xs">
        <font-awesome-icon icon="exclamation-circle" class="text-red-700" />
      </span>
      <span v-else-if="required" class="pl-2 pr-1 text-gray-500 text-xs">
        <font-awesome-icon icon="star-of-life" size="xs"></font-awesome-icon>
      </span>
    </span>
    <slot />

    <ul v-if="errors.length" class="text-sm font-bold m-0 text-red-700">
      <li v-for="error in errors" v-text="error" :key="error" />
    </ul>
    <p v-else-if="help" class="text-xs m-0 text-gray-600" v-text="help" />
  </label>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    help: {
      type: String,
      default: "",
      required: false,
    },
    error: {
      type: [String, Array, Boolean],
      default: "",
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    errors() {
      if (!this.error) {
        return [];
      }
      if (typeof this.error === "string") {
        return [this.error];
      }
      return this.error;
    },
  },
};
</script>
